/**
 * @param {Array<any>} items
 * @param {function(any, number): Promise<any>} worker
 * @param {number} limit
 * @returns {Promise<Array<any>>}
 *
 */
export async function runConcurrentPromises(items, worker, limit = 5) {
  const results = new Array(items.length)
  let i = 0
  const workers = new Array(Math.min(limit, items.length))
    .fill(0)
    .map(async () => {
      while (i < items.length) {
        const idx = i++
        try {
          results[idx] = await worker(items[idx], idx)
        } catch (e) {
          results[idx] = 0
          console.error(e)
        }
      }
    })
  await Promise.all(workers)
  return results
}
